import {
  deleteAdminUser,
  inviteAdminUser,
  setAdminUserRole,
  setAdminUserStatus,
} from "@/lib/api/endpoints";
import { isValidEmail, normalizeEmail, type Role, type UserStatus } from "@/lib/auth/access";

/**
 * User-admin mutations. The backend enforces SUPER_ADMIN and "can't manage
 * yourself / a bootstrap admin"; these wrappers only turn errors into results.
 */
type Result = { ok: true } | { ok: false; error: string };

async function run(fn: () => Promise<unknown>): Promise<Result> {
  try {
    await fn();
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : "Action failed" };
  }
}

export async function inviteUser(emailRaw: string, role: Role): Promise<Result> {
  if (!isValidEmail(emailRaw)) return { ok: false, error: "Enter a valid email." };
  return run(() => inviteAdminUser({ email: normalizeEmail(emailRaw), role }));
}

export async function changeUserRole(emailRaw: string, role: Role): Promise<Result> {
  return run(() => setAdminUserRole({ email: normalizeEmail(emailRaw), role }));
}

export async function setUserStatus(emailRaw: string, status: UserStatus): Promise<Result> {
  return run(() => setAdminUserStatus({ email: normalizeEmail(emailRaw), status }));
}

export async function removeUser(emailRaw: string): Promise<Result> {
  return run(() => deleteAdminUser(normalizeEmail(emailRaw)));
}
